export default "__VITE_ASSET__D793n4kL__"